/* tp-shelf — 蛋糕列表页 v3 的筛选 / 排序 / 展开(TP-SYNC-20261011-COLLECTION-REDESIGN-01)。
   全部商品已在 HTML 里;这里只改显示和顺序,不发请求。没有 JS 时全部卡片照常显示。
   · 两组胶囊各单选(送给谁在挑选条轨道里 / 价格在 Filters 面板里),再点一次取消;All 只清「送给谁」,Clear all 全清。数量按另一组实时算,0 款置灰。
   · 没筛选、没排序 = 默认:藏掉已在「最多人订」里的卡,先出 first 张,Show more 每次再出 batch 张;「帮你选」卡只在默认时出。
   · 后退回来(back_forward)恢复筛选 / 排序 / 已展开张数;新打开一律从头(店主 10/8)。
   · 埋点:tp_entry_click(entry = shelf_*),走 TPTrack(没有就跳过)。
   · 10/12(其他列表页套用):第三组「蛋糕线 / 版本」(ln = fc / 0sa / keto,按卡片 data-ln);选 0sa / keto 时双版本卡换成该版本的价格和 ?tp_version= 链接,清掉恢复原样。
     手动排序集合的「最多人订」:拉 tp-shelf-rank 分区(?sort_by=best-selling)拿真实名次,从网格克隆卡片;拉不到整排藏掉。
     今明模式(根 class tp-shelf--today):页头截单倒计时 + 卡片「Today or tomorrow」,同一套截单 / 周日 / 订满规则。 */
(function () {
  var root = document.querySelector('[data-tp-shelf]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = '1';

  var grid = root.querySelector('[data-tp-shelf-grid]');
  if (!grid) return;
  var items = Array.prototype.slice.call(grid.querySelectorAll('.tp-shelf__item'));
  var helps = Array.prototype.slice.call(grid.querySelectorAll('[data-help]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.tp-shelf__chip[data-g]'));
  var allChip = root.querySelector('[data-clear-who]');
  var panel = root.querySelector('[data-tp-panel]');
  var pslot = root.querySelector('[data-tp-pslot]');
  var fbtn = root.querySelector('[data-tp-fbtn]');
  var fcount = root.querySelector('[data-tp-fcount]');
  var pn = root.querySelector('[data-tp-pn]');
  var clearBtns = Array.prototype.slice.call(root.querySelectorAll('[data-clear]'));
  var sortSel = root.querySelector('[data-tp-shelf-sort]');
  var moreBtn = root.querySelector('[data-tp-shelf-more]');
  var status = root.querySelector('[data-tp-shelf-status]');
  var countEl = root.querySelector('[data-tp-shelf-count]');
  var empty = root.querySelector('[data-tp-shelf-empty]');
  var bar = root.querySelector('[data-tp-shelf-bar]');
  var top = root.querySelector('[data-tp-shelf-top]');

  var FIRST = parseInt(root.dataset.first, 10) || 16;
  var BATCH = parseInt(root.dataset.batch, 10) || 16;
  var KEY = 'tp-shelf:' + location.pathname;
  var state = { who: '', pb: '', ln: '', sort: 'featured', limit: FIRST };
  var TODAY = root.classList.contains('tp-shelf--today');
  // 应季款挪到网格最前(服务端按集合顺序输出,它们常在末尾);无 JS 时留在原位
  var season = items.filter(function (el) { return el.hasAttribute('data-season'); });
  season.slice().reverse().forEach(function (el) { grid.insertBefore(el, grid.firstChild); });
  items = Array.prototype.slice.call(grid.querySelectorAll('.tp-shelf__item'));
  var order = items.slice(); // 默认顺序 = 集合顺序(应季在前;DOM 里 help 卡穿插其间)
  var domOrder = Array.prototype.slice.call(grid.children);

  function track(entry) {
    try { if (window.TPTrack) window.TPTrack.event('tp_entry_click', { entry: entry }); } catch (e) {}
  }
  function nav(entry) {
    try { if (window.TPTrack) window.TPTrack.nav('tp_entry_click', { entry: entry }); } catch (e) {}
  }
  function matches(el, who, pb, ln) {
    if (who && el.getAttribute('data-who').indexOf('|' + who + '|') === -1) return false;
    if (pb && el.getAttribute('data-pb') !== pb) return false;
    if (ln && (el.getAttribute('data-ln') || '').indexOf('|' + ln + '|') === -1) return false;
    return true;
  }
  function anyF() { return !!(state.who || state.pb || state.ln); }

  // 选了 0 Sugar Added / Keto:双版本卡换成该版本的最低价 + 划线价 + ?tp_version=(与 tp-m-card prefer 同一参数);其余恢复原样
  var VQ = { '0sa': '0+sugar+added', keto: 'keto' };
  items.forEach(function (el) {
    var a = el.querySelector('a.tp-m-card'), p = a && a.querySelector('.tp-m-card__p');
    if (a && p) { el._tpHref = a.getAttribute('href'); el._tpP = p.innerHTML; }
  });
  function applyVersion() {
    items.forEach(function (el) {
      if (el._tpP == null) return;
      var a = el.querySelector('a.tp-m-card'), p = a.querySelector('.tp-m-card__p');
      var v = state.ln, vp = v ? el.getAttribute('data-vp-' + v) : null;
      if (vp) {
        var vc = el.getAttribute('data-vc-' + v);
        p.textContent = 'From ' + vp;
        if (vc) { var s = document.createElement('s'); s.textContent = vc; p.appendChild(document.createTextNode(' ')); p.appendChild(s); }
        a.setAttribute('href', el._tpHref.split('?')[0] + '?tp_version=' + VQ[v]);
      } else {
        p.innerHTML = el._tpP;
        a.setAttribute('href', el._tpHref);
      }
    });
  }
  function label(g, v) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].dataset.g === g && chips[i].dataset.v === v && !chips[i].classList.contains('tp-shelf__chip--w')) return chips[i].firstChild.textContent.trim(); // 跳过问句行的短标签(Her),用全称(For her)
    }
    return '';
  }
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  function sorted(list) {
    var s = state.sort;
    if (s === 'featured') return list;
    var out = list.slice();
    out.sort(function (a, b) {
      var d;
      if (s === 'price-asc') d = (+a.dataset.price) - (+b.dataset.price);
      else if (s === 'price-desc') d = (+b.dataset.price) - (+a.dataset.price);
      else d = (+b.dataset.new) - (+a.dataset.new);
      return d || ((+a.dataset.i) - (+b.dataset.i));
    });
    return out;
  }

  function render(revealFrom) {
    var filtered = !!(anyF() || state.sort !== 'featured');
    root.classList.toggle('is-filtered', filtered);

    // 顺序:默认用原 DOM 顺序(含 help 卡位置);排序时只排商品,help 卡默认态才显示所以放哪都行
    if (state.sort === 'featured') {
      domOrder.forEach(function (n) { grid.appendChild(n); });
    } else {
      sorted(order).forEach(function (n) { grid.appendChild(n); });
    }

    var list = [];
    items.forEach(function (el) {
      var inSet = matches(el, state.who, state.pb, state.ln);
      if (!filtered && el.hasAttribute('data-top')) inSet = false;
      el.classList.toggle('is-out', !inSet);
      if (inSet) list.push(el);
    });
    if (state.sort !== 'featured') list = sorted(list);

    list.forEach(function (el, idx) {
      var hide = idx >= state.limit;
      el.classList.toggle('is-more', hide);
      if (!hide && revealFrom != null && idx >= revealFrom) {
        el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
      }
    });
    // help 卡跟着它前面那张卡:前面那张被「展开」藏了,它也藏
    helps.forEach(function (h) {
      var prev = h.previousElementSibling;
      while (prev && !prev.classList.contains('tp-shelf__item')) prev = prev.previousElementSibling;
      h.hidden = !prev || prev.classList.contains('is-more') || prev.classList.contains('is-out');
    });

    var left = list.length - state.limit;
    if (moreBtn) {
      moreBtn.hidden = left <= 0;
      moreBtn.textContent = 'Show more cakes (' + Math.max(left, 0) + ')';
    }
    if (empty) empty.hidden = list.length > 0;

    // 胶囊状态 + 交叉数量
    if (allChip) {
      var noWho = !state.who;
      allChip.classList.toggle('is-on', noWho);
      allChip.setAttribute('aria-pressed', noWho ? 'true' : 'false');
      var nAll = allChip.querySelector('[data-n-all]');
      if (nAll) { var na = 0; items.forEach(function (el) { if (matches(el, '', state.pb, state.ln)) na++; }); nAll.textContent = na; }
    }
    if (fcount) { var fc = (state.pb ? 1 : 0) + (state.ln ? 1 : 0) + (state.who && !root.classList.contains('tp-shelf--who-row') ? 1 : 0); fcount.hidden = !fc; fcount.textContent = fc; }
    var wv = root.querySelector('[data-tp-whoval]'), wb = root.querySelector('[data-tp-whobtn]'), bc = root.querySelector('[data-tp-barcount]');
    if (wv) wv.textContent = state.who ? label('who', state.who) : 'Anyone';
    if (wb) wb.classList.toggle('is-set', !!state.who);
    var shown = filtered ? list.length : items.length; // 没筛选时「最多人订」那几款也算在内,和总数一致
    if (bc) bc.textContent = shown + (shown === 1 ? ' cake' : ' cakes');
    if (pn) pn.textContent = anyF() ? list.length : items.length;
    chips.forEach(function (c) {
      var g = c.dataset.g, v = c.dataset.v;
      var on = state[g] === v;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      var who = g === 'who' ? v : state.who;
      var pb = g === 'pb' ? v : state.pb;
      var ln = g === 'ln' ? v : state.ln;
      var n = 0;
      items.forEach(function (el) { if (matches(el, who, pb, ln)) n++; });
      var nEl = c.querySelector('[data-n]');
      if (nEl) nEl.textContent = n;
      c.disabled = n === 0 && !on;
    });

    if (countEl) countEl.textContent = filtered ? list.length : items.length;
    if (status) {
      if (anyF()) {
        var parts = [];
        if (state.ln) parts.push(label('ln', state.ln));
        if (state.who) parts.push(label('who', state.who));
        if (state.pb) parts.push(label('pb', state.pb));
        status.innerHTML = '';
        status.appendChild(document.createTextNode('Showing ' + list.length + (list.length === 1 ? ' cake' : ' cakes') + ' · ' + parts.join(' · ')));
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = 'Show all ' + items.length;
        b.addEventListener('click', clear);
        status.appendChild(b);
        status.hidden = false;
      } else {
        status.textContent = 'Showing all ' + items.length + ' cakes';
        status.hidden = root.classList.contains('tp-shelf--who-row') || root.classList.contains('tp-shelf--who-sheet') || root.classList.contains('tp-shelf--who-none'); // 钉顶条已写款数,不重复
      }
    }
    if (state.ln !== lastLn) { lastLn = state.ln; applyVersion(); }
    save();
  }
  var lastLn = '';

  function scrollToGrid() {
    var y = grid.getBoundingClientRect().top + window.pageYOffset - (bar ? bar.offsetHeight : 0) - 70;
    if (window.pageYOffset > y) window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
  }

  function clear() {
    state.who = ''; state.pb = ''; state.ln = ''; state.limit = FIRST;
    render();
    track('shelf_all');
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var g = c.dataset.g, v = c.dataset.v;
      state[g] = state[g] === v ? '' : v;
      state.limit = anyF() ? 999 : FIRST;
      render();
      if (!(panel && panel.classList.contains('is-open'))) scrollToGrid();
      track('shelf_' + g + '_' + (state[g] ? c.firstChild.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_') : 'off'));
    });
  });
  clearBtns.forEach(function (b) { b.addEventListener('click', clear); });
  if (allChip) allChip.addEventListener('click', function () {
    state.who = ''; state.limit = (state.pb || state.ln) ? 999 : FIRST;
    render(); scrollToGrid(); track('shelf_who_all');
  });

  // ── Filters 面板:手机 = 底部升起(打开时挪到 body 下,避开 Ella main 的层级);电脑 = 左侧常驻栏,按钮不出 ──
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  if (panel && !root.classList.contains('tp-shelf--who-track')) panel.classList.add('is-who'); // 面板挪到 body 下后读不到根 class,自己带上
  if (panel) Array.prototype.forEach.call(root.classList, function (c) { if (c.indexOf('tp-shelf--skin-') === 0) panel.classList.add(c); });
  var whobtn = root.querySelector('[data-tp-whobtn]');
  var whoval = root.querySelector('[data-tp-whoval]');
  var barcount = root.querySelector('[data-tp-barcount]');
  if (whobtn) whobtn.addEventListener('click', function () { openPanel(); if (panel) panel.scrollTop = 0; track('shelf_who_btn'); });
  var backdrop = null;
  function openPanel() {
    if (!panel || !(mqMobile && mqMobile.matches)) return;
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tp-shelf-backdrop';
      backdrop.addEventListener('click', closePanel);
    }
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);
    panel.classList.add('is-sheet');
    // 店主用预览链接看时,Shopify 预览条钉在屏幕最底下会挡住「Show N cakes」,给它让出高度(正式站没有这条)
    try {
      var pbar = document.getElementById('PBarNextFrameWrapper');
      var ph = pbar ? Math.round(pbar.getBoundingClientRect().height) : 0;
      panel.style.paddingBottom = ph > 0 ? (ph + 14) + 'px' : '';
    } catch (e) {}
    void panel.offsetWidth;
    panel.classList.add('is-open'); backdrop.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (fbtn) fbtn.setAttribute('aria-expanded', 'true');
    track('shelf_filters_open');
  }
  function closePanel(apply) {
    if (!panel || !panel.classList.contains('is-sheet')) return;
    panel.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (fbtn) fbtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      panel.classList.remove('is-sheet');
      if (pslot) pslot.appendChild(panel);
      if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
      if (apply === true) scrollToGrid();
    }, 260);
  }
  if (fbtn) fbtn.addEventListener('click', function () { if (panel && panel.classList.contains('is-open')) closePanel(); else openPanel(); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-tp-pclose]'), function (b) { b.addEventListener('click', closePanel); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-tp-papply]'), function (b) { b.addEventListener('click', function () { closePanel(true); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  if (mqMobile && mqMobile.addEventListener) mqMobile.addEventListener('change', function () { if (!mqMobile.matches) closePanel(); });

  if (sortSel) {
    sortSel.addEventListener('change', function () {
      state.sort = sortSel.value;
      if (!anyF()) state.limit = FIRST;
      render();
      track('shelf_sort_' + state.sort);
    });
  }
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var from = state.limit;
      state.limit += BATCH;
      render(from);
      track('shelf_more');
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-totop]'), function (b) {
    b.addEventListener('click', function () {
      if (top) {
        var y = top.getBoundingClientRect().top + window.pageYOffset - (bar ? bar.offsetHeight : 0) - 70;
        window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
      }
      track('shelf_help_top');
    });
  });
  // 离开本页的点击(名次卡 / 应季卡 / 链接胶囊 / 帮你选链接):排队发,落地页重放
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var host = a.closest('[data-entry]');
    var entry = a.getAttribute('data-entry') || (host ? host.getAttribute('data-entry') : '');
    if (entry) nav(entry);
  });

  if (panel) panel.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && a.getAttribute('data-entry') && !root.contains(panel)) nav(a.getAttribute('data-entry')); // 面板在 root 里时由 root 的监听发,不重复
  });

  // 后退回来才恢复
  try {
    var navType = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || {}).type;
    if (navType === 'back_forward') {
      var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (saved) {
        state.who = saved.who || ''; state.pb = saved.pb || ''; state.ln = saved.ln || '';
        state.sort = saved.sort || 'featured'; state.limit = saved.limit || FIRST;
        if (sortSel) sortSel.value = state.sort;
      }
    }
  } catch (e) {}

  // 钉顶挑选条贴在站头下面:电脑站头是 sticky(88px),手机站头上滑会藏;按站头当前底边实时算 top
  var hdr = document.querySelector('header.shopify-section-group-header-group') || document.querySelector('.shopify-section-group-header-group header-component');
  function syncTop() {
    if (!bar) return;
    var t = 0;
    if (hdr) {
      var pos = getComputedStyle(hdr).position;
      if (pos === 'sticky' || pos === 'fixed') t = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
    }
    bar.style.top = t + 'px';
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; syncTop(); });
  }, { passive: true });
  window.addEventListener('resize', syncTop);

  // ── 卡片多图:手机左右滑时圆点跟着走;电脑悬停换到第二张、移开回第一张 ──
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  Array.prototype.forEach.call(root.querySelectorAll('[data-tp-gal]'), function (gal) {
    var dots = gal.parentNode.querySelectorAll('.tp-m-card__dots i');
    var n = gal.children.length;
    var last = 0;
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / Math.max(gal.clientWidth, 1));
      if (i === last || !dots[i]) return;
      if (dots[last]) dots[last].classList.remove('is-on');
      dots[i].classList.add('is-on');
      last = i;
      if (i > 0 && !gal.dataset.swiped) { gal.dataset.swiped = '1'; track('shelf_photo_swipe'); }
    }, { passive: true });
    if (fine && n > 1) {
      var card = gal.closest('.tp-m-card');
      card.addEventListener('mouseenter', function () { gal.scrollTo({ left: gal.clientWidth, behavior: 'smooth' }); });
      card.addEventListener('mouseleave', function () { gal.scrollTo({ left: 0, behavior: 'smooth' }); });
    }
  });

  // ── 卡片「最早哪天能送」:日期由 tp-slots-manual.js 按商品页同一规则填好,这里改成「Pre-order from …」(店主 10/11:和 Same-day 标签并排会让人困惑,只留这一行) ──
  function shortenEarliest() {
    Array.prototype.forEach.call(root.querySelectorAll('.tp-shelf__early'), function (el) {
      var t = el.textContent;
      if (t.indexOf('Earliest date: ') === 0) el.textContent = 'Pre-order from ' + t.slice(15);
    });
  }
  shortenEarliest();
  setTimeout(shortenEarliest, 1500);

  // ── 截单(配送 2:30 PM 多伦多时间,周日无当天送;今天 / 明天订满也照实说)──
  //   提前订页:黄条链接「Need it today? Order within 2h 10m」;过点 / 周日 / 今天订满 →「Need it soon? Same-day & next-day cakes」。
  //   今明页:页头一行倒计时 + 卡片「Today or tomorrow」/「Tomorrow」(今天不行时);明天也订满 → 卡片不写,页头说去购物车挑日子。
  var cd = root.querySelector('[data-tp-shelf-cd]');
  var cdh = root.querySelector('[data-tp-shelf-cdh-t]');
  var tts = Array.prototype.slice.call(root.querySelectorAll('[data-tp-shelf-tt]'));
  function cutoffNow() {
    var DD = window.TPDeliveryData || {};
    var cut = ((DD.CUTOFFS || {}).delivery || '14:30').split(':');
    var noSame = DD.NO_SAMEDAY_DOW || [0];
    var fmt = function (d) {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short', hour12: false }).formatToParts(d);
      var get = function (k) { var p = parts.filter(function (x) { return x.type === k; })[0]; return p ? p.value : ''; };
      return { dow: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday').slice(0, 3)), iso: get('year') + '-' + get('month') + '-' + get('day'), h: +get('hour') % 24, m: +get('minute') };
    };
    var now = fmt(new Date());
    var tmr = fmt(new Date(Date.now() + 36e5 * 24));
    var mins = (+cut[0] * 60 + (+cut[1])) - (now.h * 60 + now.m);
    var blocked = function (iso) { try { return !!(window.TPSlots && window.TPSlots.blocked && window.TPSlots.blocked(iso)); } catch (e) { return false; } };
    return { mins: mins, today: noSame.indexOf(now.dow) === -1 && !blocked(now.iso) && mins > 0, tomorrow: !blocked(tmr.iso) };
  }
  function left(mins) { return (mins >= 60 ? Math.floor(mins / 60) + 'h ' : '') + (mins % 60) + 'm'; }
  function tickCutoff() {
    var c;
    try { c = cutoffNow(); } catch (e) { return; }
    if (cd) cd.textContent = (c.today ? 'Need it today? Order within ' + left(c.mins) : 'Need it soon? Same-day & next-day cakes') + ' ›'; // 周六晚的「明天」是周日,不在这句里许诺
    if (cdh) {
      if (c.today) cdh.textContent = 'Order within ' + left(c.mins) + ' for delivery tonight';
      else if (c.tomorrow) cdh.textContent = 'Same-day orders are closed for today — order now for tomorrow';
      else cdh.textContent = 'Today and tomorrow are fully booked — pick a later date in the cart';
    }
    if (tts.length) {
      var t = c.today && c.tomorrow ? 'Today or tomorrow' : c.today ? 'Today' : c.tomorrow ? 'Tomorrow' : '';
      tts.forEach(function (el) { el.textContent = t; el.hidden = !t; });
    }
  }
  tickCutoff();
  setInterval(tickCutoff, 30000);
  // tp-slots 的订满数据可能晚到,过一会儿再算一次
  setTimeout(tickCutoff, 1500);

  // ── 手动排序集合的「最多人订」:按 Shopify Best selling 真实名次,从网格克隆卡片(店主:名次必须是真的,拉不到就不出) ──
  var remote = root.querySelector('[data-tp-rank-remote]');
  if (remote) {
    var N = parseInt(root.dataset.topN, 10) || 5;
    var rrow = remote.querySelector('[data-tp-rank-row]');
    var byPid = {};
    items.forEach(function (el) { byPid[el.getAttribute('data-pid')] = el; });
    var qs = '?sort_by=best-selling&section_id=tp-shelf-rank';
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') qs += '&preview_theme_id=' + Shopify.theme.id; } catch (e) {}
    var fail = function () { remote.hidden = true; top = null; Array.prototype.forEach.call(root.querySelectorAll('[data-totop]'), function (b) { b.hidden = true; }); };
    fetch(location.pathname + qs, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var m = /data-tp-rank="([0-9,]*)"/.exec(html || '');
      if (!m) return fail();
      var picked = [];
      m[1].split(',').forEach(function (id) {
        var el = byPid[id];
        if (!id || !el || picked.length >= N || el.hasAttribute('data-season')) return;
        picked.push(el);
      });
      if (!picked.length) return fail();
      rrow.innerHTML = '';
      picked.forEach(function (el, k) {
        var tc = document.createElement('div');
        tc.className = 'tp-shelf__tc';
        tc.setAttribute('data-entry', 'shelf_top_' + (k + 1));
        var sdb = el.querySelector('.tp-shelf__sdbox');
        if (sdb) tc.appendChild(sdb.cloneNode(true));
        var card = el.querySelector('a.tp-m-card').cloneNode(true);
        Array.prototype.forEach.call(card.querySelectorAll('.tp-shelf__spec, .tp-shelf__early, .tp-shelf__sd'), function (n) { n.parentNode.removeChild(n); }); // 当天送蓝字行留着:有印章的卡由 CSS 显示(印章占了图边),没印章的照旧藏
        if (el._tpHref) card.setAttribute('href', el._tpHref); // 名次卡不跟版本筛选走(筛选时这一排本来就藏)
        if (el._tpP != null) { var cp = card.querySelector('.tp-m-card__p'); if (cp) cp.innerHTML = el._tpP; }
        card.setAttribute('data-rank', k + 1);
        var t = card.querySelector('.tp-m-card__t');
        if (t) {
          var r = document.createElement('span');
          r.className = 'tp-m-card__rank'; r.setAttribute('aria-label', 'Number ' + (k + 1)); r.textContent = '#' + (k + 1);
          t.insertBefore(r, t.firstChild);
        }
        tc.appendChild(card);
        rrow.appendChild(tc);
        el.setAttribute('data-top', '');
      });
      remote.classList.add('is-ready');
      render();
    }).catch(fail);
  }

  // ── 筛选胶囊横滑提示(店主 10/11:左右能滑不明显)──
  //   右侧渐隐 + 箭头;滑到头箭头翻转、点了回到开头;第一次进页轻推一下(尊重「减少动态效果」)。
  var chipRow = root.querySelector('.tp-shelf__chips');
  var chipNext = root.querySelector('[data-tp-chipnext]');
  function chipEdges() {
    if (!chipRow || !bar) return;
    var over = chipRow.scrollWidth - chipRow.clientWidth > 4;
    var atEnd = chipRow.scrollLeft + chipRow.clientWidth >= chipRow.scrollWidth - 4;
    bar.classList.toggle('has-more', over && !atEnd);
    bar.classList.toggle('at-end', over && atEnd);
    bar.classList.toggle('at-start', chipRow.scrollLeft <= 4);
  }
  if (chipRow) {
    chipRow.addEventListener('scroll', function () { requestAnimationFrame(chipEdges); }, { passive: true });
    window.addEventListener('resize', chipEdges);
  }
  if (chipNext && chipRow) {
    chipNext.addEventListener('click', function () {
      if (bar.classList.contains('at-end')) chipRow.scrollTo({ left: 0, behavior: 'smooth' });
      else chipRow.scrollBy({ left: Math.round(chipRow.clientWidth * 0.7), behavior: 'smooth' });
      track('shelf_chip_arrow');
    });
  }
  function nudge() {
    try {
      if (!chipRow || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (chipRow.scrollWidth - chipRow.clientWidth < 20 || chipRow.scrollLeft > 0) return;
      setTimeout(function () {
        if (chipRow.scrollLeft > 0) return;
        chipRow.scrollTo({ left: 56, behavior: 'smooth' });
        setTimeout(function () { chipRow.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
      }, 900);
    } catch (e) {}
  }

  root.classList.add('is-js');
  render();
  syncTop();
  chipEdges();
  nudge();
})();
